import React, { useMemo } from 'react';
import { ErrorContainer, ErrorText } from './ErrorMessage.styles';
import { StableCoinOption } from 'pages/open-position/index.page';
import { useBalanceDai, useBalanceUsdc, useBalanceUsdt, useOusdCollateralMinimum } from '@components/store/getters';
import { ErrorType } from '../..';
import { naturalNumber } from '@components/eth/Utils';

interface ErrorMessageProps {
  selectedStableCoin?: StableCoinOption;
  type?: ErrorType;
}

export const ErrorMessage = ({ selectedStableCoin, type }: ErrorMessageProps) => {
  const usdcBalance = useBalanceUsdc();
  const usdtBalance = useBalanceUsdt();
  const daiBalance = useBalanceDai();
  const minimumDeposit = useOusdCollateralMinimum();

  const stableCoinBalance = useMemo(() => {
    switch (selectedStableCoin?.value) {
      case 'usdc':
        return Number(usdcBalance);
      case 'dai':
        return Number(daiBalance);
      default:
        return Number(usdtBalance);
    }
  }, [selectedStableCoin]);

  const errorContent = useMemo(() => {
    if (type === 'depositGreaterThanBalance')
      return <ErrorText type="span">Insufficient Balance: {naturalNumber(stableCoinBalance)}</ErrorText>;
    if (type === 'depositLessThanMinimum')
      return (
        <ErrorText type="span">Deposit minimum is {Number(minimumDeposit)}. Please enter a higher amount.</ErrorText>
      );
  }, [type]);

  return <ErrorContainer>{errorContent}</ErrorContainer>;
};
